import { useQuery } from '@tanstack/react-query'
import {
	type GetQueueListingsParams,
	httpGetQueueListings
} from '@/features/luxe-submissions/http/luxe-submissions.http'

export const QUEUE_LISTINGS_QUERY_KEY = 'queue-listings'

export const useGetQueueListings = (params: GetQueueListingsParams = {}) =>
	useQuery({
		queryKey: [QUEUE_LISTINGS_QUERY_KEY, params],
		queryFn: () => httpGetQueueListings(params)
	})
